var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('dynamic-component-config-manager',{attrs:{"entry":_vm.entry}},[(_vm.entry && _vm.configManager().debugDynamicComponentsEnabled() && _vm.configManager().showHiddenDynamicComponentsEnabled())?_c('div',{},[_vm._v(" "+_vm._s(_vm.value || 'nan')+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }